import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './CakeSignup.css';

const CakeSignup = () => {
  const navigate = useNavigate();

  const [formData, setFormData] = useState({
    shop_name: '',
    owner_name: '',
    email: '',
    mobile: '',
    password: '',
    confirm_password: '',
    address: '',
    city: '',
    state: '',
    pincode: '',
  });

  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState('');
  const [messageType, setMessageType] = useState('');

  const handleChange = (e) => {
    const { name, value } = e.target;

    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));

    if (message) {
      setMessage('');
      setMessageType('');
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (
      !formData.shop_name.trim() ||
      !formData.owner_name.trim() ||
      !formData.email.trim() ||
      !formData.password
    ) {
      setMessage('Please fill all required fields.');
      setMessageType('error');
      return;
    }

    if (formData.password.length < 6) {
      setMessage('Password must be at least 6 characters.');
      setMessageType('error');
      return;
    }

    if (formData.password !== formData.confirm_password) {
      setMessage('Password and Confirm Password do not match.');
      setMessageType('error');
      return;
    }

    setLoading(true);
    setMessage('');
    setMessageType('');

    try {
      const response = await fetch('/api/cake/auth/signup', {
        method: 'POST',

        headers: {
          'Content-Type': 'application/json',
        },

        body: JSON.stringify({
          shop_name: formData.shop_name.trim(),
          owner_name: formData.owner_name.trim(),
          email: formData.email.trim(),
          mobile: formData.mobile.trim(),
          password: formData.password,
          address: formData.address.trim(),
          city: formData.city.trim(),
          state: formData.state.trim(),
          pincode: formData.pincode.trim(),
        }),
      });

      const data = await response.json();

      if (!response.ok) {
        throw new Error(
          data.message || 'Signup failed. Please try again.'
        );
      }

      setMessage(
        'Registration successful. Your account is waiting for approval.'
      );
      setMessageType('success');

      setFormData({
        shop_name: '',
        owner_name: '',
        email: '',
        mobile: '',
        password: '',
        confirm_password: '',
        address: '',
        city: '',
        state: '',
        pincode: '',
      });

      setTimeout(() => {
        navigate('/cake/login');
      }, 1800);

    } catch (error) {
      console.error('Cake signup error:', error);

      setMessage(
        error.message || 'Something went wrong. Please try again.'
      );
      setMessageType('error');

    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="cake-signup-page">

      <div className="cake-signup-topbar">

        <div
          className="cake-signup-brand"
          onClick={() => navigate('/')}
        >
          <div className="cake-signup-logo">
            🎂
          </div>

          <div>
            <h2>VAKRA CAKE</h2>
            <span>Cake Business Platform</span>
          </div>
        </div>

        <div className="cake-signup-login-link">
          Already have an account?

          <button
            type="button"
            onClick={() => navigate('/cake/login')}
          >
            Login
          </button>
        </div>

      </div>


      <main className="cake-signup-main">

        <div className="cake-signup-left">

          <div className="cake-signup-left-content">

            <span className="cake-signup-badge">
              Start Your Cake Business Journey
            </span>

            <h1>
              Manage Your Cake Business
              <span> Smarter with VAKRA</span>
            </h1>

            <p>
              Create your cake shop account and manage products,
              orders, customers, billing and records from one simple
              platform.
            </p>

            <div className="cake-signup-benefits">

              <div className="cake-signup-benefit">
                <div className="cake-signup-benefit-icon">🎂</div>

                <div>
                  <strong>Manage Your Cakes</strong>
                  <span>
                    Add cake products, prices, weights and flavors.
                  </span>
                </div>
              </div>

              <div className="cake-signup-benefit">
                <div className="cake-signup-benefit-icon">📦</div>

                <div>
                  <strong>Receive Online Orders</strong>
                  <span>
                    Manage customer orders from one place.
                  </span>
                </div>
              </div>

              <div className="cake-signup-benefit">
                <div className="cake-signup-benefit-icon">📊</div>

                <div>
                  <strong>Business Records</strong>
                  <span>
                    Keep your orders, customers and sales organized.
                  </span>
                </div>
              </div>

            </div>

          </div>

        </div>


        <div className="cake-signup-right">

          <div className="cake-signup-card">

            <div className="cake-signup-heading">
              <h2>Create Your Account</h2>

              <p>
                Register your cake shop or home baking business.
              </p>
            </div>


            {message && (
              <div
                className={
                  messageType === 'success'
                    ? 'cake-signup-message success'
                    : 'cake-signup-message error'
                }
              >
                {message}
              </div>
            )}


            <form
              className="cake-signup-form"
              onSubmit={handleSubmit}
            >

              <div className="cake-form-grid">

                <div className="cake-form-group cake-full-width">
                  <label>
                    Cake Shop / Business Name
                    <span>*</span>
                  </label>

                  <input
                    type="text"
                    name="shop_name"
                    value={formData.shop_name}
                    onChange={handleChange}
                    placeholder="Example: Sweet Cake House"
                    autoComplete="organization"
                  />
                </div>


                <div className="cake-form-group">
                  <label>
                    Owner Name
                    <span>*</span>
                  </label>

                  <input
                    type="text"
                    name="owner_name"
                    value={formData.owner_name}
                    onChange={handleChange}
                    placeholder="Owner name"
                    autoComplete="name"
                  />
                </div>


                <div className="cake-form-group">
                  <label>
                    Mobile Number
                  </label>

                  <input
                    type="tel"
                    name="mobile"
                    value={formData.mobile}
                    onChange={handleChange}
                    placeholder="10 digit mobile number"
                    maxLength="15"
                    autoComplete="tel"
                  />
                </div>


                <div className="cake-form-group cake-full-width">
                  <label>
                    Email Address
                    <span>*</span>
                  </label>

                  <input
                    type="email"
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                    placeholder="your@email.com"
                    autoComplete="email"
                  />
                </div>


                <div className="cake-form-group">
                  <label>
                    Password
                    <span>*</span>
                  </label>

                  <input
                    type="password"
                    name="password"
                    value={formData.password}
                    onChange={handleChange}
                    placeholder="Minimum 6 characters"
                    autoComplete="new-password"
                  />
                </div>


                <div className="cake-form-group">
                  <label>
                    Confirm Password
                    <span>*</span>
                  </label>

                  <input
                    type="password"
                    name="confirm_password"
                    value={formData.confirm_password}
                    onChange={handleChange}
                    placeholder="Enter password again"
                    autoComplete="new-password"
                  />
                </div>


                <div className="cake-form-group cake-full-width">
                  <label>
                    Shop Address
                  </label>

                  <textarea
                    name="address"
                    value={formData.address}
                    onChange={handleChange}
                    placeholder="Shop / business address"
                    rows="3"
                  />
                </div>


                <div className="cake-form-group">
                  <label>
                    City
                  </label>

                  <input
                    type="text"
                    name="city"
                    value={formData.city}
                    onChange={handleChange}
                    placeholder="City"
                  />
                </div>


                <div className="cake-form-group">
                  <label>
                    State
                  </label>

                  <input
                    type="text"
                    name="state"
                    value={formData.state}
                    onChange={handleChange}
                    placeholder="State"
                  />
                </div>


                <div className="cake-form-group cake-full-width">
                  <label>
                    Pincode
                  </label>

                  <input
                    type="text"
                    name="pincode"
                    value={formData.pincode}
                    onChange={handleChange}
                    placeholder="Pincode"
                    maxLength="10"
                  />
                </div>

              </div>


              <div className="cake-signup-note">
                By creating an account, your registration will be
                submitted to VAKRA for approval.
              </div>


              <button
                type="submit"
                className="cake-create-account-button"
                disabled={loading}
              >
                {loading
                  ? 'Creating Account...'
                  : 'Create Account'}
              </button>


              <div className="cake-signup-bottom-login">
                Already registered?

                <button
                  type="button"
                  onClick={() => navigate('/cake/login')}
                >
                  Login here
                </button>
              </div>

            </form>

          </div>

        </div>

      </main>

    </div>
  );
};

export default CakeSignup;
